import { computed, ref } from '@vue/composition-api';

export default function usePeerConnection() {
  const connection = ref(null);

  function createConnection() {
    connection.value = new RTCPeerConnection({
      iceServers: [
        {
          username: process.env.VUE_APP_TURN_USER,
          urls: `${process.env.VUE_APP_TURN_SCHEME}:${process.env.VUE_APP_TURN_SERVER}`,
          credential: process.env.VUE_APP_TURN_PASSWORD,
        },
      ],
    });
  }

  createConnection();

  async function restartConnection() {
    connection.value.onicecandidate = null;
    await connection.value.close();
    connection.value = null;
    createConnection();
  }

  function onIceCandidate(callback) {
    connection.value.onicecandidate = (event) => {
      if (!event.candidate || !event.candidate.candidate) {
        callback();
      } else {
        callback({
          candidate: event.candidate.candidate,
          sdpMid: event.candidate.sdpMid,
          sdpMLineIndex: event.candidate.sdpMLineIndex,
        });
      }
    };
  }

  function removeTracksFromConnection(tracks) {
    if (!tracks || !tracks.length) {
      return;
    }
    tracks.forEach((t) => connection.value.removeTrack(t));
  }

  return {
    connection: computed(() => connection.value),
    onIceCandidate,
    removeTracksFromConnection,
    restartConnection,
  };
}
